import React from 'react';

/**
 * Component to display a line between different steps in the stepper component.
 * @constructor
 */
const StepperLine = () => {
    return <div className={'stepper-line'} />
}

export default StepperLine;